import type { WaveTodoMentionCandidate } from "@vida/wave-core";
import { WaveAuthorAvatar } from "../presence/WaveAuthorAvatar";
import { WaveAgentAvatar } from "../presence/WaveAgentAvatar";
import type { WaveParticipantRecord } from "@vida/wave-core";

type Props = {
  candidates: WaveTodoMentionCandidate[];
  selectedIndex: number;
  participants: WaveParticipantRecord[];
  onSelect: (candidate: WaveTodoMentionCandidate) => void;
  onHover: (index: number) => void;
};

export function WaveTodoMentionPicker({
  candidates,
  selectedIndex,
  participants,
  onSelect,
  onHover,
}: Props) {
  if (candidates.length === 0) {
    return (
      <div className="wave-todo-mention-picker" role="listbox" aria-label="Menziona">
        <p className="wave-todo-mention-empty muted">Nessun risultato</p>
      </div>
    );
  }

  return (
    <div className="wave-todo-mention-picker" role="listbox" aria-label="Menziona">
      {candidates.map((candidate, index) => (
        <button
          key={candidate.ref}
          type="button"
          role="option"
          aria-selected={index === selectedIndex}
          className={`wave-todo-mention-option${index === selectedIndex ? " selected" : ""}`}
          onMouseDown={(e) => e.preventDefault()}
          onMouseEnter={() => onHover(index)}
          onClick={() => onSelect(candidate)}
        >
          {candidate.kind === "agent" ? (
            candidate.iconS3Key || candidate.glyph ? (
              <WaveAgentAvatar
                name={candidate.label}
                emoji={candidate.glyph}
                iconS3Key={candidate.iconS3Key}
                size={22}
              />
            ) : (
              <span className="wave-todo-mention-glyph" aria-hidden>
                🤖
              </span>
            )
          ) : (
            <WaveAuthorAvatar authorSub={candidate.ref} participants={participants} size={22} />
          )}
          <span className="wave-todo-mention-label">@{candidate.label}</span>
          {candidate.subtitle && candidate.kind === "participant" && (
            <span className="wave-todo-mention-sub muted">{candidate.subtitle}</span>
          )}
          {candidate.kind === "agent" && (
            <span className="wave-todo-mention-sub muted">Agente AI</span>
          )}
        </button>
      ))}
    </div>
  );
}
